import { render, staticRenderFns } from "./zhuoCard.vue?vue&type=template&id=30384a82&scoped=true"
import script from "./zhuoCard.vue?vue&type=script&lang=js"
export * from "./zhuoCard.vue?vue&type=script&lang=js"
import style0 from "./zhuoCard.vue?vue&type=style&index=0&id=30384a82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30384a82",
  null
  
)

export default component.exports